<template>
  <div class="open-shop-settle">
    <div class="step-4">
      <div class="title-1">{{$t('openShopSettle.账单结算')}}</div>
      <div class="title-2">{{$t('openShopSettle.应缴周期数')}}：{{number}}{{$t('openShopSettle.期')}}</div>
      <template v-if="stepFour.data.offline_pay.length">
        <div class="item">
          <div class="title">{{$t('openShop.线下商品支付')}}</div>
          <div class="goods" v-for="value in stepFour.data.offline_pay" :key="value.progress_choose_id">
            <div class="left">
              <el-image :src="value.progress_choose_target.service_image[0]" fit="cover"></el-image>
              <span>{{value.progress_choose_target.service_name}}</span>
            </div>
            <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_price / 100).toFixed(2)}}</div>
          </div>
        </div>
        <div class="sum">{{$t('openShop.线下支付总价')}}：NZD ${{(stepFour.data.offlinePaySum / 100).toFixed(2)}}</div>
        <el-divider></el-divider>
      </template>
      <div class="item" v-if="stepFour.data.online_pay.TEMPLATE.length">
        <div class="title">{{$t('openShop.已选模板')}}</div>
        <div class="goods" v-for="value in stepFour.data.online_pay.TEMPLATE" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.template_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.template_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.template_price / 100).toFixed(2)}}</div>
        </div>
      </div>
      <div class="item" v-if="stepFour.data.online_pay.SHOP_PAYMENT.length">
        <div class="title">{{$t('openShop.绑定的支付渠道')}}</div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SHOP_PAYMENT" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.shop_payment_icon" fit="cover"></el-image>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.shop_payment_price / 100).toFixed(2)}}</div>
        </div>
      </div>
      <div class="item" v-if="stepFour.data.online_pay.SERVICE_PACKAGE.length || stepFour.data.online_pay.SERVICE.length || stepFour.data.online_pay.SERVICE_MODEL">
        <div class="title">{{$t('openShop.已选商品')}}</div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SERVICE_PACKAGE" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.service_package_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.service_package_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_package_price / 100).toFixed(2)}}</div>
        </div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SERVICE" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.service_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.service_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_price / 100).toFixed(2)}}</div>
        </div>
        <div class="goods" v-for="value in stepFour.data.online_pay.SERVICE_MODEL" :key="value.progress_choose_id">
          <div class="left">
            <el-image :src="value.progress_choose_target.service_model_image[0]" fit="cover"></el-image>
            <span>{{value.progress_choose_target.service_model_name}}</span>
          </div>
          <div class="right">{{$t('openShop.订阅费')}}：NZD ${{(value.progress_choose_target.service_model_price / 100).toFixed(2)}}</div>
        </div>
      </div>
      <div class="sum">{{$t('openShop.线上支付总价')}}：NZD ${{(stepFour.data.onlinePaySum / 100).toFixed(2)}}</div>
      <el-button @click="stepFourSubmit">{{$t('openShop.立即线上支付')}}</el-button>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      id: this.$route.params.id,
      number: 0,
      stepFour: {
        loading: false,
        data: {
          offline_pay: [],
          online_pay: {
            TEMPLATE: [],
            SHOP_PAYMENT: [],
            SERVICE_PACKAGE: [],
            SERVICE: []
          }
        }
      }
    }
  },
  mounted() {
    this.setDefaultLanguage()
    this.initPage()
  },
  methods: {
    initPage() {
      request({
        baseURL: process.env.VUE_APP_BASE_URL_EXTERNAL,
        url: `/progress/order/email/back/${this.id}`,
        method: 'get'
      }).then(res => {
        this.number = res.data.progress_order_data.progress_order_index
        let offlinePaySum = 0
        res.data.offline_pay.forEach(value => {
          offlinePaySum = this.add(value.progress_choose_target.service_price, offlinePaySum)
        })
        res.data.offlinePaySum = offlinePaySum
        let onlinePaySum = 0
        res.data.online_pay.TEMPLATE.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.template_price, onlinePaySum)
        })
        res.data.online_pay.SERVICE_PACKAGE.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.service_package_price, onlinePaySum)
        })
        res.data.online_pay.SERVICE.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.service_price, onlinePaySum)
        })
        res.data.online_pay.SERVICE_MODEL.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.service_model_price, onlinePaySum)
        })
        res.data.online_pay.SHOP_PAYMENT.forEach(value => {
          onlinePaySum = this.add(value.progress_choose_target.shop_payment_price, onlinePaySum)
        })
        res.data.onlinePaySum = onlinePaySum
        this.stepFour.data = res.data
      })
    },
    add(num1, num2) {
      let baseNum1
      let baseNum2
      try {
        baseNum1 = num1.toString().split('.')[1].length
      } catch (e) {
        baseNum1 = 0
      }
      try {
        baseNum2 = num2.toString().split('.')[1].length
      } catch (e) {
        baseNum2 = 0
      }
      const baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
      return (num1 * baseNum + num2 * baseNum) / baseNum
    },
    setDefaultLanguage() {
      let lang = ''

      if (this.$route.query.lang) {
        lang = this.$route.query.lang
      } else if (location.host.includes('ieshop.co.nz')) {
        lang = 'en'
      }

      if (lang === 'en' || lang === 'zh') {
        this.setLanguage(lang)
      }
    },
    setLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)
    },
    stepFourSubmit() {
      window.open(this.stepFour.data.progress_order_data.progress_order_pay_url)
      this.$confirm(null, this.$t('openShopSettle.支付信息'), {
        confirmButtonText: this.$t('openShopSettle.已支付'),
        cancelButtonText: this.$t('openShopSettle.未支付')
      }).then(() => {
        request({
          baseURL: process.env.VUE_APP_BASE_URL_EXTERNAL,
          url: `/progress/order/check/payed/${this.id}`,
          method: 'get'
        }).then(res => {
          if (res.data.status) {
            this.$router.push({
              name: 'Home'
            })
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .open-shop-settle {
    .title-1 {
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .title-2 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 40px;
    }
    .step-4 {
      width: 60%;
      margin: 48px auto 0 auto;
      & > .el-button {
        min-width: 110px;
        margin: 48px auto;
        border: none;
        background-color: #96BF47;
        color: #ffffff;
        padding: 13px 20px;
        display: block;
        border-radius: 20px;
      }
      .item {
        margin-bottom: 32px;
        .title {
          font-size: 24px;
          color: #96BF47;
          font-weight: bold;
          margin-bottom: 24px;
        }
        .goods {
          display: flex;
          align-items: center;
          justify-content: space-between;
          &:not(:last-of-type) {
            margin-bottom: 16px;
          }
          .left {
            display: flex;
            align-items: center;
            font-size: 14px;
            .el-image {
              width: 120px;
              height: 90px;
              border-radius: 4px;
              margin-right: 16px;
            }
          }
          .right {
            font-size: 14px;
            color: #FBA718;
          }
        }
      }
      .sum {
        text-align: right;
        font-size: 20px;
        color: #FBA718;
      }
    }
  }
</style>
